import * as THREE from 'three';
import {
    OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js';
import './style.css';

const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene();
const textureLoader = new THREE.TextureLoader();
const seaColorTexture = textureLoader.load('textures/manifesto.png');
const seaHeightTexture = textureLoader.load('textures/manifesto.png');
const alphaTexture = textureLoader.load('textures/manifesto.png');

const material = new THREE.MeshStandardMaterial();
material.roughness = 1;
material.metalness = 0;
material.displacementMap = seaHeightTexture;
material.alphaMap = alphaTexture;
material.map = seaColorTexture;
// material.side = THREE.DoubleSide;
material.wireframe = false;
material.transparent = true;

material.displacementScale = 0.1;


console.log(`
           !YJ^         ^^7^
            ^? 7^~^     !G7            ^7J~
57!~^^~!777!^   ~&@&@5   ~G ~        ^^7G&&@@5
J@@@@@@@@&@@@@#5~^G@@ !   ^5#~ ~?JYYJP7.?@@@@#^
7@@@@@@@~  GGG@@@#&@#       ~~J@@@@ ~P~  #@@@7
~7~#@@@#~ 7! ~@@@@G77~     7&@@@@G  5  5@@#7
  @@@@@@@@@@@@@&&#!     5@@@@& PPGY5GY~
  ~J5PJ!75#&&G7J?       ^ @ !
           ^^
`);
const plane = new THREE.Mesh(new THREE.PlaneBufferGeometry(1, 1, 1000, 1000), material);


const hemiLight = new THREE.HemisphereLight(0x000000, 0x111111, 4);

scene.add(plane);
scene.add(hemiLight)

// const light = new THREE.SpotLight(0x000000,4);
// light.position.set(-50,50,50);
// light.castShadow = true;
// scene.add( light );

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 1
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
});

const tick = () => {
    // Update controls
    controls.update()
    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
};

tick();